import { Optional } from 'functions/promiseExtensions';
import * as UnitLightList from 'types/Unit/UnitLightList';
import * as UnitWeight from 'types/UnitWeight/UnitWeight';

export type Type = UnitWeight.Type[];

export function create(): Type {
	return [];
}

export function add(
	unitWeights: Type,
	unitSuggestions: UnitLightList.Type,
	selectedUnitIndex: number,
	weight: number
): Type {
	return Optional.Maybe(unitSuggestions[selectedUnitIndex])
		.map((unit) => [
			...unitWeights,
			{
				id: unit.id,
				weight: weight,
				name: unit.description,
			} as UnitWeight.Type,
		])
		.getOrDefault(unitWeights);
}

export function remove(unitWeights: Type, unitWeight: UnitWeight.Type): Type {
	return unitWeights.filter((e) => e.id !== unitWeight.id);
}
